import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Baseproperties } from "./baseproperties";
import { HttpClient } from "@angular/common/http";
import { SortEvent } from "primeng/api";
import * as CryptoJS from 'crypto-js';


@Injectable({providedIn: 'root'})
  export class Utilityservice{
    headerObservable=new BehaviorSubject<any>(null);
    refreshfilter=new BehaviorSubject<any>('');
    baseproperties: Baseproperties = new Baseproperties(); 
    private baseURL = this.baseproperties.gatewayBaseURL 
    private commonUrl=this.baseproperties.gatewayBaseURL+'/common'
    constructor(private httpClient:HttpClient){}
    observable_scrollHieght=new BehaviorSubject<any>('');
    scrollHeight: string = '340.8px'; // Set your common scroll height here
     
    private configParamsSubject = new BehaviorSubject<any>(null); 
    configParams$ = this.configParamsSubject.asObservable();
    productdetail(){
      return { userid:3,orgid:1,productid:8,componentname:'auditdashboard' }
    }
    public logout() {
            return this.httpClient.get(`${this.commonUrl}/generic/logout/`);
      // localStorage.clear();
      // window.location.href = location.origin + "/common/#/login"
  }

   logoutAndRedirect() {
  let subdomain = window.location.hostname.split('.')[0];
  const baseDomain = window.location.hostname.split('.').slice(-2).join('.');

  this.logout().subscribe(() => {
    if (["complinity.in","complinity.com","complinity.info"].includes(baseDomain)) {

      this.checkorginitial({ subdomain }).subscribe({
        next: (res) => {
          if (res?.length > 0) {

            if (subdomain === "rasi") {
              localStorage.clear();
              window.location.href = "https://portal.rasiseeds.com/adfs/ls/?wa=wsignout1.0";
              return;
            }

            if (subdomain === "maxhealthcare") {
              localStorage.clear();
              window.location.href = "https://maxcrm.maxhealthcare.com/adfs/ls/?wa=wsignout1.0";
              return;
            }
          }

          this.defaultRedirect();
        },
        error: () => this.defaultRedirect()
      });

    } else {
      this.defaultRedirect();
    }
  });
}

defaultRedirect() {
  localStorage.clear();
  window.location.replace(location.origin + "/common/#/login"); // 🔥 better than href
}
   public checkorginitial(data: any): Observable<any> {
        
        return this.httpClient.post(this.commonUrl + "/api/checkorginitial",data);
    }
  getverticalforlist(): Observable<any>{
    return this.httpClient.get<Observable<any>>(`${this.commonUrl}/vertical/verticaldata`);
  }

  getLoggeduser() {
    if(localStorage.getItem('userdata')!==null){
      return JSON.parse(localStorage.getItem('userdata'));
  } else{
      return undefined
  }

  }
  getsessiontoken() {
    if(localStorage.getItem('pagetoken')!==null){
      return JSON.parse(localStorage.getItem('pagetoken'));
  } else{
      return undefined
  }

  }
  getUserRights(){
    if(localStorage.getItem('userRights')!==null){
    return JSON.parse(localStorage.getItem('userRights'));
    }else{
      return undefined
    }

  }
  getnavigationuserbasedList() {
      return [
          {
              roletype: 1,
              labelheding: 'Common Master',
              items: [
                  { subheading: 'User', link: 'common/#/common/user', icon: 'pi pi-user' },
                  { subheading: 'Location', link: 'common/#/common/location', icon: 'pi pi-globe' },
                  { subheading: 'Vertical', link: 'common/#/common/vertical', icon: 'pi pi-book' },
                  { subheading: 'Entity', link: 'common/#/common/entity', icon: 'pi pi-book' },
                  { subheading: 'Region', link: 'common/#/common/region', icon: 'pi pi-book' },
                  { subheading: 'City', link: 'common/#/common/city', icon: 'pi pi-book' },
                  { subheading: 'Hub', link: '/common/#/common/hub', icon: 'pi pi-book' }
              ]
          },
          {
              roletype: 1,
              labelheding: 'Common Reports',
              items: [
                  { subheading: 'Common dashboard', link: '/common/#/common/common-dashboard', icon: 'pi pi-user' },
                  { subheading: 'Version Update', link: '', icon: 'pi pi-user' },
                  { subheading: 'E-Signature', link: '', icon: 'pi pi-user' },
                  { subheading: 'User Log Report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Client User Report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Data change log report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Clint usage report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Common Master Backup', link: '', icon: 'pi pi-user' },
                  { subheading: 'CUstomer satisfaction servey', link: '', icon: 'pi pi-user' },
                  { subheading: 'Customer servey report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Organisation statics', link: '', icon: 'pi pi-user' }
              ]
          },
          {
              roletype: 1,
              labelheding: 'Common Reports2',
              items: [
                  { subheading: 'Common dashboard', link: '/common/#/common/common-dashboard', icon: 'pi pi-user' },
                  { subheading: 'Version Update', link: '', icon: 'pi pi-user' },
                  { subheading: 'E-Signature', link: '', icon: 'pi pi-user' },
                  { subheading: 'User Log Report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Client User Report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Data change log report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Clint usage report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Common Master Backup', link: '', icon: 'pi pi-user' },
                  { subheading: 'CUstomer satisfaction servey', link: '', icon: 'pi pi-user' },
                  { subheading: 'Customer servey report', link: '', icon: 'pi pi-user' },
                  { subheading: 'Organisation statics', link: '', icon: 'pi pi-user' }
              ]
          }

      ]
  }
  getOptionDropdown(length):Array<any>{
    let options=[]
    let pairSize = 10;
    let numberOfPairs = Math.ceil(length / pairSize);   // Calculate the number of pairs
    let pairsArray = Array.from({ length: numberOfPairs }, (_, index) => {
      const end = Math.min((index + 1) * pairSize, length); // Create the array of pairs
      return [end];
    });
    pairsArray.map((e)=>{
      options.push({'label':e[0],value:e[0]})
    });
    return options
  }
    savefilterxuser(payload): Observable<any> {
      return this.httpClient.post(`${this.baseURL}/audit/generic/adduserxcolumn`,payload);
    }
    resetuserxcolumn(payload):Observable<any>{
      return this.httpClient.post(`${this.baseURL}/audit/generic/resetuserxcolumn`,payload)
    }
    getuserxcolumn(payload): Observable<any> {
      return this.httpClient.post(`${this.baseURL}/common/generic/userxcolumn`,payload);
    }
    getCSRFtoken() : Observable<any>{
      return this.httpClient.get(`${this.baseURL}/common/generic/csrf`);
  
    }
    fileUpload(data: FormData): Observable<any> {    
      return this.httpClient.post<Observable<any>>(`${this.baseURL}/audit/generic/upload`, data);
    }
    bulkUploadExcel(data: FormData,url): Observable<any> {    
      return this.httpClient.post<Observable<any>>(`${this.baseURL}/${url}`, data);
    }
    getAttachmentData(payload): Observable<any> {
      return this.httpClient.post(`${this.baseURL}/audit/generic/getattachments/`,payload);
    }
     // download attachment by id
  downloadattachmentfile(apiurl){
    return this.httpClient.get(`${this.baseURL}/${apiurl}`,{ responseType: 'blob' });
  }
    deleteAttachmentbyId(id){
      // deleteattachment/{fileid}
      return this.httpClient.get(`${this.baseURL}/audit/generic/deleteattachment/${id}`);

    }
    getusernavigation(user): Observable<any> {
      return this.httpClient.post(`${this.commonUrl}/gen/getProductsByUser/`,user);
    }
    
    getmasterconfigparams():Observable<any>{
            return this.httpClient.get(`${this.commonUrl}/generic/commonmasterconfigparams/`);

    }
    sortData(field: string, order: number,tabledata:Array<any>) {      
      tabledata.sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];
    
        let result = 0;
        if (valueA < valueB) {
          result = -1;
        } else if (valueA > valueB) {
          result = 1;
        }
        return order * result;
      });
    }

    columnFilter(event, tabledata) {
      let filtered = [...tabledata];
      let gloabalFilterFields=[]
      for (var key in event.filters) {
        gloabalFilterFields.push(key)
    }
      if (event.globalFilter) {
        const globalFilterValue = event.globalFilter.toLowerCase();

        filtered = filtered.filter(item =>
          gloabalFilterFields.some(field =>
                item[field] &&
                item[field].toString().toLowerCase().includes(globalFilterValue)
            )
        );
    }
      // Handle column-specific filters
      if (event.filters) {
        // delete event.filters.global
          for (let key in event.filters) {
              let filterMeta = event.filters[key];
              if (filterMeta && filterMeta.length > 0) {
                  filterMeta.forEach((meta) => {
                      if (meta.value) {
                          if (meta.matchMode === 'notContains') {
                              filtered = filtered.filter(item => !item[key] || !item[key].toString().toLowerCase().includes(meta.value.toLowerCase()));
                          } else {
                              filtered = filtered.filter(item => item[key] && item[key].toString().toLowerCase().includes(meta.value.toLowerCase()));
                          }
                      }
                  });
              }
          }
      }
       tabledata = filtered;
      return tabledata;
  }
  public isUserValidFor(object: string, right: string): boolean {
    let l = JSON.parse(localStorage.getItem('login'));
    if (l == undefined || l == null) {
        return false;
    }
    let v: Array<any> = l.objectAccess;
    if (v.length > 0) {
        for (let i = 0; i < v.length; i++) {
            if (v[i].objectName == object) {
                if (right == 'view') {
                    return v[i].viewAllRights || v[i].viewRights;
                }
                if (right == 'create') {
                    return v[i].createRights;
                }
                if (right == 'edit') {
                    return v[i].editRights;
                }
                if (right == 'delete') {
                    return v[i].deleteRights;
                }
            }
        }
    }
    return false;
}
isMobile(): boolean {
    return window.innerWidth <= 768;
  }
 updateScrollHeight() {
    const windowHeight = window.innerHeight;

  // Adjust this calculation based on your header, footer, or other non-table elements' height
  const headerHeight = 230; // Estimate height of your buttons, filters, and margins
  const availableHeight = windowHeight - headerHeight;

  return `${availableHeight}px`;
  }
  stringFromNumArray(list){
    const data=(list.split(','));
    const numberArray=data.map(e=> Number(e));
    return numberArray
   }
   onlyNumberKey(evt) {
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57 || evt.target.value.length > 5))
      return false;
    return true;
  }
 onlyNumberKeywithoutlen(evt) {
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
      return false;
    return true;
  }


  updateScrollHeightforAudit() {
    const windowHeight = window.innerHeight;    
    const percentage = 0.58; // Adjust this value as needed    
    return `${windowHeight * percentage}px`;
  }

  downloadExcelData(api,http,payload) {       
    if(http=='get'){
    return this.httpClient.get(`${this.baseURL}/${api}`, { responseType: 'blob' });  // audit generate excel
    }else{
      return this.httpClient.post(`${this.baseURL}/${api}`,payload, { responseType: 'blob' });  // audit generate excel

    }
  }
 
 
  setstringifnull(value){
    if(value==null)
    {
     return value=''
    }else{
      return value
    }
  }
  customSort(event: SortEvent) {               
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = 0;

        // Convert date strings to Date objects if they are valid date formats
        const isDate = (date) => !isNaN(Date.parse(date));
        
        if (value1 == null && value2 != null) result = -1;
        else if (value1 != null && value2 == null) result = 1;
        else if (value1 == null && value2 == null) result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string') {
            if (isDate(value1) && isDate(value2)) {
                const date1 = new Date(value1);
                const date2 = new Date(value2);
                result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
            } else {
                result = value1.localeCompare(value2);
            }
        } else {
            result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
        }

        return event.order * result;  // Multiply by order (-1 for descending, 1 for ascending)
    });
}
fetchAndStoreConfigParams(): void {
  this.getmasterconfigparams().subscribe({
    next: (res) => {      
     if(res.length>0)
     {
       this.configParamsSubject.next(res[0].response[0]);
     }else{
      this.configParamsSubject.next([]);
     }
    }
  });
}

private secretKey = CryptoJS.enc.Utf8.parse('e8ffc7e56311679f');
encryptData(data: any): string {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    this.secretKey,
    {
      mode: CryptoJS.mode.ECB,  
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return encrypted.toString(); 
}
decryptData(encryptedText: string): any {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      encryptedText,
      this.secretKey,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedText);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}

fileacceptdata(){
  return  {
    filenotallow:['.dll','.json','.exe','.java'],
    maxfilesize:'1GB',
    minfilesize:'0kb',
    maxfiles:'1',
    minimumfiles:'0',
    isfilerequired:false
  }

}

    getFilevalidation() {
    if(localStorage.getItem('filevalidation')!==null){
      return JSON.parse(localStorage.getItem('filevalidation'));
  } else{
      return undefined
  }
}

    getserverandorg():Observable<any>{
            return this.httpClient.get(`${this.commonUrl}/generic/serverandorg/`);

    }


}